var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBtnVideoStop = function SvgBtnVideoStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#191D23",
    fillOpacity: 0.75,
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.15 11.26a1 1 0 0 1 1 1v7.48a1 1 0 0 1-2 0v-7.48a1 1 0 0 1 1-1m5.7 0a1 1 0 0 1 1 1v7.48a1 1 0 0 1-2 0v-7.48a1 1 0 0 1 1-1"
  })));
};
export default SvgBtnVideoStop;